import { Injectable } from '@angular/core';
import { ApiConfig} from '../_helpers/api-config'
import { AppSettings } from '../_helpers/app.settings';
import { Request } from '../_helpers/request';
import { HttpService } from '../shared/http.service';
@Injectable({
  providedIn: 'root'
})
export class LicensingService {

  constructor(private http: HttpService) { 
  }
  toggleLicense(param: any){
    let req: Request = {
      method: AppSettings.HTTP_METHODS.GET,
      url: `${ApiConfig.toggleLicense}${param.data.customerCode}`,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  deleteLicense(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.DELETE,
      url: `${ApiConfig.deleteLicense}${param.data.customerCode}`,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  downloadLicense(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.GET,
      url: `${ApiConfig.downloadLicense}${param.data.customerCode}`,
      downloadFile: true,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
    
  }
  fetchLicenseDetail(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.GET,
      url: `${ApiConfig.getLicenseDetail}${param.data.customerCode}`,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  createLicense(param: any) {
    let req: Request = {
        method: AppSettings.HTTP_METHODS.POST,
        url: `${ApiConfig.createLicense}`,
        reqBody: param.data,
        success: param.success ? param.success : null,
        error: param.error ? param.error : null
      }
      this.http.sendRequest(req);
  }
  editLicense(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.POST,
      url: `${ApiConfig.updateLicense}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  fetchLicenses(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.POST,
      url: `${ApiConfig.fetchLicenses}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
}
